/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import type { AutocompleteResult as AutocompleteResultsType } from '@zcode/bizos'
import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { AutocompleteBoxType, SaveSearchLocationBox } from '@zcode/state-type'
import { AUTOCOMPLETE_NEIGHBORHOOD } from '../../../../shared/components/Autocomplete/constants'

export const trackAutocompleteGeosMismatch = (
  autocompleteResult: Partial<
    Pick<AutocompleteResultsType, 'box' | 'city' | 'lat' | 'lng' | 'name' | 'type' | 'url'>
  >,
  geoLocation: {
    url?: string
    cityName?: string
    hoodName?: string
    box?: AutocompleteBoxType | SaveSearchLocationBox | null | undefined
    lat?: number | null
    lng?: number | null
  }
) => {
  track({
    event: EVENT_NAMES.AUTOCOMPLETE_GEOS_MISMATCH,
    payload: {
      [PROP_NAMES.AUTOCOMPLETE_URL]: autocompleteResult.url,
      [PROP_NAMES.GEOS_URL]: geoLocation.url,
      [PROP_NAMES.AUTOCOMPLETE_CITY_NAME]: autocompleteResult.city,
      [PROP_NAMES.GEOS_CITY_NAME]: geoLocation.cityName,
      [PROP_NAMES.AUTOCOMPLETE_HOOD_NAME]:
        autocompleteResult.type === AUTOCOMPLETE_NEIGHBORHOOD ? autocompleteResult.name : undefined,
      [PROP_NAMES.GEOS_HOOD_NAME]:
        autocompleteResult.type === AUTOCOMPLETE_NEIGHBORHOOD ? geoLocation.hoodName : undefined,
      [PROP_NAMES.AUTOCOMPLETE_BOX]: autocompleteResult.box,
      [PROP_NAMES.GEOS_BOX]: geoLocation.box,
      [PROP_NAMES.AUTOCOMPLETE_LAT]: autocompleteResult.lat,
      [PROP_NAMES.GEOS_LAT]: geoLocation.lat,
      [PROP_NAMES.AUTOCOMPLETE_LNG]: autocompleteResult.lng,
      [PROP_NAMES.GEOS_LNG]: geoLocation.lng,
      [PROP_NAMES.AUTOCOMPLETE_NAME]: autocompleteResult.name,
      [PROP_NAMES.AUTOCOMPLETE_TYPE]: autocompleteResult.type,
    },
  })
}
